import axios from 'axios';

/**
 * 用户友好，可呈现给用户的错误类型
 */
export class UserFriendlyError extends Error {
  __USER_FRIENDLY__ = true;
}

/**
 * 网络请求取消异常
 */
export const ApiCancelError = axios.Cancel;

/**
 * 接口响应业务异常
 * @extends UserFriendlyError
 */
export class ApiBusinessError extends UserFriendlyError {
  name = 'ApiBusinessError';
  errcode: number;
  data?: any;
  errmsg: string;

  constructor(message: string, code: number, data?: any) {
    super(message);

    this.errcode = code;
    this.data = data;
    // 兼容
    this.errmsg = message;
  }
}

/**
 * 接口响应网络异常
 * @extends UserFriendlyError
 */
export class ApiNetError extends UserFriendlyError {
  name = 'ApiNetError';
  errcode: number;
  errmsg: string;

  constructor(message: string, code: number) {
    super(message);

    this.errcode = code; // 兼容
    this.errmsg = message;
  }
}
